import React, { useMemo } from 'react';
import propTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { Multiple } from '../../../components/multiple-text-blurb-for-grid';
import OrderNumberLink from '../../../components/order-number-link';
import { FulfillmentPlanCounter } from '../../fulfillment-plan-counter';
import { useSalesOrderForFulfillmentId } from '../../../hooks/entities/selectors/fulfillments';
import Global from '../../../store/global-selectors';
import { sortByAsc } from '../../../services/sort-service';
import { messages } from '../messages';

const OrderNumberColumn = ({ fulfillmentId }) => {
  const ret = useSelector((state) => Global.selectEntitiesReturnById(state, { fulfillmentId }));

  const { fulfillmentPlanId } = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};
  const salesOrdersFulfilledIds = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'salesOrdersFulfilledIds',
    }),
  );
  const salesOrder = useSalesOrderForFulfillmentId(fulfillmentId);

  const { salesOrderId, orderNumber, store = {}, assignedToUserId, fulfillmentPlanIds } = salesOrder;
  const { storeGuid } = store;
  const sortedFulfillmentPlanIds = useMemo(() => [...(fulfillmentPlanIds ?? [])].sort(sortByAsc), [fulfillmentPlanIds]);

  const orderNumberMessage = useMemo(
    () =>
      fulfillmentPlanIds?.length > 1 ? (
        <FulfillmentPlanCounter
          count={sortedFulfillmentPlanIds.indexOf(fulfillmentPlanId) + 1}
          orderNumber={orderNumber}
          total={sortedFulfillmentPlanIds.length}
        />
      ) : (
        orderNumber
      ),
    [fulfillmentPlanIds, sortedFulfillmentPlanIds, fulfillmentPlanId, orderNumber],
  );

  if (ret) {
    return (
      <OrderNumberLink
        id={ret.fulfillmentPlanId}
        orderNumber={ret.orderNumber}
        returnFulfillmentId={fulfillmentId}
        salesOrderAssignedUserId={ret.salesOrderAssignedUser}
        salesOrderId={ret.salesOrderId}
        storeGuid={ret.storeGuid}
      />
    );
  }

  if (salesOrdersFulfilledIds > 1) {
    return <Multiple />;
  }

  if (!orderNumber) {
    return '';
  }

  return (
    <OrderNumberLink
      id={fulfillmentPlanId}
      orderNumber={orderNumberMessage}
      salesOrderAssignedUserId={assignedToUserId}
      salesOrderId={salesOrderId}
      storeGuid={storeGuid}
    />
  );
};

OrderNumberColumn.propTypes = {
  fulfillmentId: propTypes.string.isRequired,
};

export const OrderNumber = {
  getMessageDescriptor: () => messages.orderNumber,
  id: 'order-number',

  render: (data) => {
    if (!data) {
      return '';
    }
    return <OrderNumberColumn fulfillmentId={data.id} />;
  },
};
